export default __webpack_public_path__ + "static/media/computer.cf9c39e2.svg";